import { render } from "./InitInputImg.vue?vue&type=template&id=71393854&scoped=true"
import script from "./InitInputImg.vue?vue&type=script&lang=js"
export * from "./InitInputImg.vue?vue&type=script&lang=js"

import "./InitInputImg.vue?vue&type=style&index=0&id=71393854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71393854"]])

export default __exports__